<template>
  <main class="flex flex-col">
    <header class="bg-gray-400 sm:flex sm:justify-between sm:items-center sm:px-4 sm:py-3">
      <div class="flex items-center justify-between px-4 py-3 sm:p-0">
        <div>
          <img
            class="h-auto w-40"
            src="./assets/images/LogoHof.png"
            alt="Hof Logo"
          />
        </div>
        <div class="flex flex-row sm:hidden">
          <router-link to="/cart">
            <div class="flex flex-row mt-2 block px-2 py-1 text-green-800 font-semibold hover:text-orange-700 sm:mt-0 sm:ml-2 active:text-orange-700">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="24"
                height="24"
              >
                <path
                  class="heroicon-ui fill-current text-green-800"
                  d="M17 16a3 3 0 1 1-2.83 2H9.83a3 3 0 1 1-5.62-.1A3 3 0 0 1 5 12V4H3a1 1 0 1 1 0-2h3a1 1 0 0 1 1 1v1h14a1 1 0 0 1 .9 1.45l-4 8a1 1 0 0 1-.9.55H5a1 1 0 0 0 0 2h12zM7 12h9.38l3-6H7v6zm0 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm10 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
                />
              </svg>
              <div class="ml-2 mr-4 flex bg-orange-600 text-lg text-white rounded-lg w-8 justify-center">
                {{ showCartAmount }}
              </div>
            </div>
          </router-link>

          <button
            @click="isOpen = !isOpen"
            type="button"
            class="block text-green-800 hover:text-green-800 focus:text-green-800 focus:outline-none"
          >
            <svg
              class="h-6 w-6 fill-current"
              viewBox="0 0 24 24"
            >
              <path
                v-if="isOpen"
                fill-rule="evenodd"
                d="M18.278 16.864a1 1 0 0 1-1.414 1.414l-4.829-4.828-4.828 4.828a1 1 0 0 1-1.414-1.414l4.828-4.829-4.828-4.828a1 1 0 0 1 1.414-1.414l4.829 4.828 4.828-4.828a1 1 0 1 1 1.414 1.414l-4.828 4.829 4.828 4.828z"
              />
              <path
                v-if="!isOpen"
                fill-rule="evenodd"
                d="M4 5h16a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2z"
              />
            </svg>
          </button>
        </div>
      </div>

      <nav
        :class="isOpen ? 'block' : 'hidden'"
        class="px-2 pt-2 pb-4 sm:flex sm:p-0 mt-4"
      >
        <router-link to="/cart">
          <div class="hidden sm:flex flex-row mt-2 block px-2 py-1 text-green-800 font-semibold hover:text-orange-700 sm:mt-0 sm:ml-2 active:text-orange-700">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="24"
              height="24"
            >
              <path
                class="heroicon-ui fill-current text-green-800"
                d="M17 16a3 3 0 1 1-2.83 2H9.83a3 3 0 1 1-5.62-.1A3 3 0 0 1 5 12V4H3a1 1 0 1 1 0-2h3a1 1 0 0 1 1 1v1h14a1 1 0 0 1 .9 1.45l-4 8a1 1 0 0 1-.9.55H5a1 1 0 0 0 0 2h12zM7 12h9.38l3-6H7v6zm0 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm10 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
              />
            </svg>
            <div class="ml-2 mr-4 flex bg-orange-600 text-lg text-white rounded-lg w-8 justify-center">
              {{ showCartAmount }}
            </div>
          </div>

        </router-link>

        <router-link
          to="/categorie"
          class="block px-2 py-1 text-green-800 font-semibold rounded hover:text-orange-700 active:text-orange-700"
        >
          <div class="flex flex-row">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="24"
              height="24"
            >
              <path
                class="heroicon-ui fill-current text-green-800"
                d="M2.59 13.41A1.98 1.98 0 0 1 2 12V7a5 5 0 0 1 5-5h4.99c.53 0 1.04.2 1.42.59l8 8a2 2 0 0 1 0 2.82l-8 8a2 2 0 0 1-2.82 0l-8-8zM20 12l-8-8H7a3 3 0 0 0-3 3v5l8 8 8-8zM7 8a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"
              />
            </svg>

            <span class="ml-2">Kategorien</span>
          </div>
        </router-link>

        <router-link
          to="/vendors"
          class="mt-2 block px-2 py-1 text-green-800 font-semibold hover:text-orange-700 sm:mt-0 sm:ml-2 active:text-orange-700"
        >
          <div class="flex flex-row">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="24"
              height="24"
            >
              <path
                class="heroicon-ui fill-current text-green-800"
                d="M13 20v-5h-2v5a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-7.59l-.3.3a1 1 0 1 1-1.4-1.42l9-9a1 1 0 0 1 1.4 0l9 9a1 1 0 0 1-1.4 1.42l-.3-.3V20a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2zm5 0v-9.59l-6-6-6 6V20h3v-5c0-1.1.9-2 2-2h2a2 2 0 0 1 2 2v5h3z"
              />
            </svg>
            <span class="ml-2">Höfe</span>
          </div>
        </router-link>

      </nav>
    </header>

    <div class="min-h-screen">
      <router-view />
    </div>

    <!-- footer  -->
    <footer class="py-8 text-center bg-gray-400">
      <router-link
        to="/login"
        class="mt-2 block px-2 py-1 text-green-800 font-semibold rounded hover:text-orange-700 sm:mt-0 sm:ml-2 active:text-orange-700"
      >
        <div class="flex flex-row">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width="24"
            height="24"
          >
            <path
              class="heroicon-ui fill-current text-green-800"
              d="M9 10h10a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-8c0-1.1.9-2 2-2h2V7a5 5 0 1 1 10 0 1 1 0 0 1-2 0 3 3 0 0 0-6 0v3zm-4 2v8h14v-8H5zm7 2a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1z"
            />
          </svg>
          <span class="ml-2">Partner</span>
        </div>
      </router-link>

      <p class="text-sm my-4 text-green-800">
        <router-link to="/imprint">Impressum</router-link> I
        <router-link to="/legal">Rechtliches</router-link> I
        <router-link to="/dataprotection">Datenschutz</router-link>
      </p>
    </footer>
  </main>
</template>

<script>
import "./assets/css/tailwind.scss";
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["showCartAmount"])
  },
  data() {
    return {
      isOpen: false
    };
  }
};
</script>

<style>
body {
  background-color: rgb(247, 241, 241);
}
.li {
  color: orange;
}
</style>
